import { useCallback, useEffect } from "react";
import { API } from "../../data/siteData";

export default function useSessionLoader({ lastActivityRef, setActiveUser }) {
  const loadSession = useCallback(async () => {
    const response = await fetch(`${API}/auth/me`, { credentials: "include" });
    if (!response.ok) {
      setActiveUser(null);
      return;
    }
    setActiveUser(await response.json());
    lastActivityRef.current = Date.now();
  }, [lastActivityRef, setActiveUser]);

  useEffect(() => {
    void loadSession();
    window.addEventListener("gameday-session-started", loadSession);
    return () => window.removeEventListener("gameday-session-started", loadSession);
  }, [loadSession]);
}